import { Box, IconButton, Popover, Typography } from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';

type Props = {
	open: boolean;
	anchorEl: HTMLElement | null;
	handleClose: () => void;
	selectedSale: Order | null;
};

function StatusPopover({ anchorEl, handleClose, open, selectedSale }: Props) {
	return (
		<Popover
			id={`popover-${selectedSale?._id}`}
			open={open}
			anchorEl={anchorEl}
			onClose={handleClose}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'left',
			}}
		>
			<Box sx={{ p: 2, maxWidth: 300 }}>
				<Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
					<Typography variant="subtitle1">Detalle del estado</Typography>
					<IconButton onClick={handleClose} size="small">
						<CloseIcon fontSize="small" />
					</IconButton>
				</Box>
				<Typography variant="body2" sx={{ mt: 1 }}>
					{selectedSale?.status === 'closed' && (
						<>
							<span>Confirmado por </span>
							<strong>{selectedSale.confirmedBy?.username ?? 'sistema'}</strong>
							<span>
								{' '}
								el {moment(selectedSale.confirmationDate).format('DD/MM/YYYY')} a las{' '}
								{moment(selectedSale.confirmationDate).format('HH:mm')}
							</span>
						</>
					)}

					{selectedSale?.status === 'cancelled' && (
						<Box sx={{ display: 'flex', flexDirection: 'column' }}>
							<Box>
								<span>Devolución realizada por </span>
								<strong>{selectedSale.cancelledBy?.username}</strong>
								<span>
									{' '}
									el {moment(selectedSale.cancellationDate).format('DD/MM/YYYY')} a las{' '}
									{moment(selectedSale.cancellationDate).format('HH:mm')}
								</span>
							</Box>
							<Typography variant="body1" sx={{ mt: 2, mb: 2 }}>
								Aprobaciones:
							</Typography>
							<Box sx={{ display: 'flex', flexDirection: 'column' }}>
								{selectedSale.approvals?.map((approval) => {
									return (
										<Box>
											<strong>{approval.approvedBy}</strong>
											<span> ({approval.status}) </span>
											<span>
												{' '}
												el {moment(approval.date).format('DD/MM/YYYY')} a las {moment(approval.date).format('HH:mm')}
											</span>
										</Box>
									);
								})}
							</Box>
						</Box>
					)}
					{selectedSale?.status !== 'closed' &&
						selectedSale?.status !== 'cancelled' &&
						'No hay información adicional para este estado.'}
				</Typography>
			</Box>
		</Popover>
	);
}

export default StatusPopover;
